import * as React from 'react';
import cn from '~modules/cn';

import './toggle.scss';

type ToggleProps = {
    onChange: (state: boolean) => void;
    checked: boolean;
    id: string;
    className?: string;
    disabled?: boolean;
    tooltip?: string | undefined;
    showLabels?: boolean;
    offLabel?: string;
    onLabel?: string;
};

export const defaultProps: Partial<ToggleProps> = {
    disabled: false,
    showLabels: true,
    offLabel: 'Off',
    onLabel: 'On'
};

export const Toggle = (props: ToggleProps): JSX.Element => {
    const { onChange, checked, id, className, disabled, tooltip, showLabels, offLabel, onLabel } = {
        ...defaultProps,
        ...props
    };

    const handleChange = function (event: React.ChangeEvent<HTMLInputElement>) {
        const value = event.target.checked;
        onChange(value);
    };

    return (
        <div className={cn('toggle-button', className, { 'toggle-button--disabled': disabled })} data-tip={tooltip}>
            {showLabels && <div className="toggle-button__state-label">{offLabel}</div>}
            <input className="toggle-button__input" id={id} type="checkbox" checked={checked} onChange={handleChange} disabled={disabled} />
            <label className="toggle-button__label" htmlFor={id} />
            {showLabels && <div className="toggle-button__state-label">{onLabel}</div>}
        </div>
    );
};

export default Toggle;
